<template>
    <section :class="['parametric-results', {'is-processing': isProc}]">
        <h1 class="parametric-results__title">
            {{ isEstateFlat ? 'Квартиры' : 'Коммерческая' }}
            <span class="parametric-results__label">{{ flats.length }}</span>
        </h1>

        <OpenFilter/>

        <div :class="['parametric-results__sort-panel', {'is-active': isShowPanel, 'is-header': isScrollUp}]">
            <ul class="parametric-results__cards-sort">
                <li><Sort :name="'Этаж'" :type="'floor'"/></li>
                <li><Sort :name="'Сдача'" :type="'deadline'"/></li>
                <li><Sort :name="'Цена'" :type="'price'"/></li>
            </ul>

            <OpenFilterSimple/>
        </div>

        <table v-if="view === 'desktop' && flats.length" :class="['parametric-results__table',
            isEstateFlat ? 'parametric-results__table_theme_flat' : 'parametric-results__table_theme_commerce']">
            <thead>
            <tr>
                <td>Планировка</td>
                <td class="parametric-row__title-cell">
                    <Sort :name="isEstateFlat ? 'Квартира' : 'Помещение'" :type="'type'"/>
                </td>
                <td class="parametric-row__area-cell"><Sort :name="'S, м<sup>2</sup>'" :type="'area'"/></td>
                <td v-if="isEstateFlat"><Sort :name="'Этаж'" :type="'floor'"/></td>
                <td><Sort :name="'Сдача'" :type="'deadline'"/></td>
                <td v-if="!hiddenPrices" class="parametric-row__price-cell">
                    <Sort :name="'Цена, руб'" :type="'price'"/>
                </td>
                <td v-else class="parametric-row__price-cell">Цена, руб</td>
            </tr>
            </thead>
            <tbody>
                <Row v-for="flat in showFlats" :flat="flat" :key="flat.id" :isEstateFlat="isEstateFlat"/>
            </tbody>
        </table>

        <div ref="cards" v-if="view === 'mobile' && flats.length" class="parametric-results__cards">
            <ul class="parametric-results__cards-sort">
                <!-- Если влезут можно добавить и эти -->
                <!--<li><Sort :name="'Квартира'" :type="'type'"/></li>-->
                <li v-if="!isEstateFlat"><Sort :name="'Площадь'" :type="'area'"/></li>
                <li v-if="isEstateFlat"><Sort :name="'Этаж'" :type="'floor'"/></li>
                <li><Sort :name="'Сдача'" :type="'deadline'"/></li>
                <li><Sort :name="'Цена'" :type="'price'"/></li>
            </ul>

            <div class="parametric-results__cards-items">
                <Card v-for="flat in showFlats" :flat="flat" :key="flat.id"/>
            </div>
        </div>

        <div v-if="counterHidden > 0" class="parametric-results__button-more">
            <More
                :counterHidden="counterHidden"
                :counterFlats="this.flats.length"
            />
        </div>

        <div v-if="!flats.length" class="parametric-results__no-result">
            <DustRunnerIcon/>
            <h4 class="parametric-results__no-result-title">Вы совершили невозможное!</h4>
            <p class="parametric-results__no-result-description">
                {{ isEstateFlat ? 'Квартир' : 'Коммерческих помещений' }} не найдено. Пожалуйста, измените параметры
                фильтра
            </p>
            <ArrowIcon/>
        </div>
    </section>
</template>

<script>
import ArrowIcon from '../svg-media/arrow.vue';
import Card from './Card/Card.vue';
import DustRunnerIcon from '../svg-media/dustrunner.vue';
import {mapGetters} from 'vuex';
import More from '../More/More.vue';
import OpenFilter from '../OpenFilter/OpenFilter.vue';
import OpenFilterSimple from '../OpenFilter/OpenFilterSimple.vue';
import Row from './Row/Row.vue';
import Sort from '../Sort/Sort.vue';
import Utils from 'common/scripts/utils';

export default {
    data() {
        return {
            isShowPanel   : false,
            isScrollUp    : false,
            scrollPosition: 0
        };
    },

    components: {
        ArrowIcon,
        Card,
        DustRunnerIcon,
        Row,
        More,
        Sort,
        OpenFilter,
        OpenFilterSimple
    },

    created() {
        this.bindEvents();
        this.showSortPanel();
    },

    computed: {
        ...mapGetters({
            view        : 'GET_VIEW',
            flats       : 'GET_FLATS',
            page        : 'GET_PAGE',
            isProc      : 'GET_IS_PROCESSING',
            estateType  : 'GET_ESTATETYPE',
            hiddenPrices: 'GET_HIDDENPRICES'
        }),

        // Количество показанных, складывается из текущей страницы и настройки.
        counterVisible() {
            return this.page * this.$appOptions.showItemPage;
        },

        // Количество скрытых, разница между общим количеством и уже показанных.
        counterHidden() {
            return this.flats.length - this.counterVisible;
        },

        showFlats() {
            if (!this.flats.length) {
                return false;
            }

            return this.flats.filter((item, index) => {
                return index < this.counterVisible;
            });
        },
        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    methods: {
        bindEvents() {
            window.addEventListener('resize', this.showSortPanel);
        },

        showSortPanel() {
            if (Utils.isBreakpoint(320, 670)) {
                this.bindScrollEvents();
            } else {
                this.unbindScrollEvents();
                this.isShowPanel = false;
                this.isScrollUp = false;
            }
        },

        bindScrollEvents() {
            window.addEventListener('scroll', this.setPanelState);
        },

        unbindScrollEvents() {
            window.removeEventListener('scroll', this.setPanelState);
        },

        setPanelState() {
            if (this.$refs.cards) {
                this.isShowPanel = this.$refs.cards.getBoundingClientRect().top <= 0 &&
                    this.$refs.cards.getBoundingClientRect().bottom >= 0;

                this.isScrollUp = document.body.getBoundingClientRect().top > this.scrollPosition &&
                    this.$refs.cards.getBoundingClientRect().top <= 0;

                this.scrollPosition = document.body.getBoundingClientRect().top;
            }
        }
    }
};
</script>
